import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_confirmaEncu } from 'app/idiomas/i18n/confirmarEncu/confirmaEncu.lang';
import { EstatusService } from 'app/main/wizard-cgo/services/statusEncuesta.service';
// import { SurveyStatusService } from 'app/main/pagina/wizard-cgo/tools/survey-status/survey-status.service';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import * as backInter from 'app/auth/auth-data.model';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import {MatSnackBar} from '@angular/material/snack-bar';
@Component({
  selector: 'app-estatus-encuesta',
  templateUrl: './estatus-encuesta.component.html',
  styleUrls: ['./estatus-encuesta.component.scss']
})
export class EstatusEncuestaComponent implements OnInit {
statusSurvey:number;//variable que habilita btn cerrarEncuesta o abrirEncuesta;
// Datos certificar vigente
productoCertificar: backInter.prodPulseCheck;
token:any;
instituto:any;
idSurvey:any;
cerrarEncuestaResul: number;

  constructor(
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private statusEncuesta: EstatusService,
    private programacionService: ProgramacionService,
    private wizardService: WizardService,
    private _snackBar: MatSnackBar,
  ) {
    lang_confirmaEncu.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    }); }

  ngOnInit() {
    console.log("Pulse estatus encuesta");
    this.obtieneCertificarActual();
    this.obtieneInstituto();
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; break;
      case '3': case 'HK': this.instituto = 'HK'; break;
      case '4': case 'SGP': this.instituto = 'SGP'; break;
      case '5': case 'TK': this.instituto = 'TK'; break;
      case '6': case 'FL': this.instituto = 'FL'; break;
      case '11': case 'BR': this.instituto = 'BR'; break;
    }
    console.log("Instituto "+this.instituto);
  }


  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.programacionService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      console.log(data);
      let prodsCertificar:backInter.prodPulseCheck[] = data.productosPulseCheck;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {

            let fecha = producto.fechaPulseCheck;
            let idProducto = producto.idPulseCheck;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              this.token=producto.tokenConfig;
              this.idSurvey=producto.idSurvey
              console.log("su token de la empresa ese",this.token);
              this.getStatusEncuesta();
              this.getAvance_Estatus();
              throw BreakException;
            }


          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };


    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }



  activarEncuesta(){
    let mensajeTexto1 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE1';
    let mensajeTexto2 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE2';
    let confirmarEmpresa = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.VALIDAR';
    this.translateSrv.get(mensajeTexto1).subscribe((res: string) => { mensajeTexto1 = res; });
    this.translateSrv.get(mensajeTexto2).subscribe((res: string) => { mensajeTexto2 = res; });
    this.translateSrv.get(confirmarEmpresa).subscribe((res: string) => { confirmarEmpresa = res; });

    let salir = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SALIR';
    let errorNombreEmpresa = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.ERRORNOMBREEMPRESA';
    this.translateSrv.get(salir).subscribe((res: string) => { salir = res; });
    this.translateSrv.get(errorNombreEmpresa).subscribe((res: string) => { errorNombreEmpresa = res; });
    let cerrar = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.CERRAR';
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    let r = Math.random().toString(36).substring(7);
    console.log("cadena de datos aleatorios: ",r);
    let codigo=r;
    Swal.fire({
      title: mensajeTexto1+'<font color="red">'+codigo+'</font>'+mensajeTexto2,
      icon: 'info',
      input:'text',
      showCancelButton: true,
reverseButtons: true,


      cancelButtonText: salir,
      confirmButtonText: confirmarEmpresa
    })
    .then( (borrar) => {
      console.log(borrar);
      if (borrar.value==codigo) {

        this.actualizaEstatusEncuestaAbierta();
        // .then( (borrar) => {
        //   Swal.showLoading();
        //   console.log(borrar);
        //   if (borrar.value) {
        //     Swal.showLoading();
        //   }
        // });
      }
      else{
        if(!borrar.dismiss){
          Swal.fire({
          icon: 'error',
          title: errorNombreEmpresa,
          showConfirmButton: true,

          confirmButtonText: cerrar
          })
        }

      }
    });
  }


actualizaEstatusEncuestaAbierta(){
  let success = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SUCCES';
  this.translateSrv.get(success).subscribe((res: string) => { success = res; });
  let estatus=3;
    let datos={
      status:1
    }
    console.log("datos Open: ",datos);

    this.statusEncuesta.activarEstatusSurveyPulse(datos,this.productoCertificar.idPulseCheck).subscribe((data:any) => {
      console.log(data);
      /*Swal.fire({
        title: success,
        icon: 'success',
        showCancelButton: false,

        confirmButtonText: 'Ok',
      })*/
      this.openSnackBar(success,"OK");

      this.getStatusEncuesta();
      this.cambioEstatusConfirmacionCompleto(estatus);

    });
  }

  cambioEstatusConfirmacionCompleto(estatus){
    let datos = {confirmacion: estatus};
    this.wizardService.guardaStatusStepPulse(datos, this.productoCertificar.idPulseCheck).subscribe( (data: backInter.RespuestaGen) => {
      console.log(data);
      if(data.message == '218'){
        this.enviaOrdenWizard();
      };
      //this.buscaCodigoSuccess(data);
    });

    /*this.statusEncuesta.guardaStatusConfirmacionPulse( this.productoCertificar.idPulseCheck, estatus).subscribe( (data: backInter.RespuestaGen) => {
    console.log(data);
      if(data.message == '216'){
        this.enviaOrdenWizard();
      };
    });*/
  }

desactivarEncuesta(){
  let mensajeTexto1 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE5';
  let mensajeTexto2 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE6';
  let btnAceptar = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.BTN-ACEPTAR';
  let btnCancelar = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.BTN-CANCELAR';
  let btnOk = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.BTN-OK';
  this.translateSrv.get(mensajeTexto1).subscribe((res: string) => { mensajeTexto1 = res; });
  this.translateSrv.get(mensajeTexto2).subscribe((res: string) => { mensajeTexto2 = res; });
  this.translateSrv.get(btnAceptar).subscribe((res: string) => { btnAceptar = res; });
  this.translateSrv.get(btnCancelar).subscribe((res: string) => { btnCancelar = res; });
  this.translateSrv.get(btnOk).subscribe((res: string) => { btnOk = res; });

  if (this.token){
if(this.cerrarEncuestaResul>0){
Swal.fire({
  title: mensajeTexto1,
  icon: 'warning',
  showCancelButton: true,
reverseButtons: true,


  confirmButtonText: btnAceptar,
  cancelButtonText: btnCancelar
}).then((result) => {
  if (result.value) {
    this.codigoValidacionCerrarEncuesta();
  }
});
}else{
  this.codigoValidacionCerrarEncuesta();
}
}else{
  Swal.fire({
    title: mensajeTexto2,
    icon: 'success',
    showCancelButton: false,

    confirmButtonText: btnOk,
  })
}

}


codigoValidacionCerrarEncuesta(){
    let mensajeTexto3 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE3';
    let mensajeTexto4 = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.MESSAGE4';
    let confirmarEmpresa = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.VALIDAR';
    let salir = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SALIR';
    let errorNombreEmpresa = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.ERRORNOMBREEMPRESA';
    let cerrar = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.CERRAR';

    this.translateSrv.get(mensajeTexto3).subscribe((res: string) => { mensajeTexto3 = res; });
    this.translateSrv.get(mensajeTexto4).subscribe((res: string) => { mensajeTexto4 = res; });
    this.translateSrv.get(confirmarEmpresa).subscribe((res: string) => { confirmarEmpresa = res; });
    this.translateSrv.get(salir).subscribe((res: string) => { salir = res; });
    this.translateSrv.get(errorNombreEmpresa).subscribe((res: string) => { errorNombreEmpresa = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    let r = Math.random().toString(36).substring(7);
    console.log("cadena de datos aleatorios: ",r);

    let codigo=r;
    Swal.fire({
      title: mensajeTexto3+'<font color="red">'+ codigo+'</font>'+mensajeTexto4,
      icon: 'info',
      input:'text',
      showCancelButton: true,
reverseButtons: true,


      cancelButtonText: salir,
      confirmButtonText: confirmarEmpresa
    })
    .then( (borrar) => {
      console.log(borrar);
      if (borrar.value==codigo) {

        this.actualizaEstatusEncuestaCerrado();


      }
      else{
        if(!borrar.dismiss){
          Swal.fire({
          icon: 'error',
          title: errorNombreEmpresa,
          showConfirmButton: true,

          confirmButtonText: cerrar
          })
        }

      }
    });
  }

  actualizaEstatusEncuestaCerrado(){
    let successdes = 'CONFIRMACION.BOTONES-MODALES.ELIMINAR.SUCCES-DES';
    this.translateSrv.get(successdes).subscribe((res: string) => { successdes = res; });
    let estatus=2;
    let datos={
      status:0
    }
    console.log("datos que cierran la encuesta: ",datos);

    this.statusEncuesta.activarEstatusSurveyPulse(datos,this.productoCertificar.idPulseCheck).subscribe((data:any) => {
      console.log(data);
      this.openSnackBar(successdes,"OK");
      /*Swal.fire({
        title: successdes,
        icon: 'success',
        showCancelButton: false,

        confirmButtonText: 'Ok',
      })*/
      this.getStatusEncuesta();
      this.cambioEstatusConfirmacionCompleto(estatus);

    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getStatusEncuesta(){
    this.statusEncuesta.getEstatusCierreEncuesta(this.token).subscribe((resul: any)=>{
      console.log(resul);
      this.statusSurvey=resul.result.id_status
   });
  }

  getAvance_Estatus(){
    this.statusEncuesta.getResult_Encuesta(this.idSurvey,this.instituto,this.token).subscribe((resul: any)=>{
      console.log(resul);
      this.cerrarEncuestaResul=resul.result.endUsers;
      console.log("encuestas contestadas: ",this.cerrarEncuestaResul);

   });

  }

  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

}
